import type { AutomationJobStatus } from "../types";

export const automationActionTypes = [
  { id: "pcm.postcard", name: "Postcard (PostcardMania)" },
  { id: "pcm.letter", name: "Letter (PostcardMania)" },
];

export const actionTypeLabel = (actionType: string): string =>
  automationActionTypes.find((a) => a.id === actionType)?.name ?? actionType;

/** Badge styling per job status — money states get loud colors. */
export const jobStatusStyles: Record<AutomationJobStatus, string> = {
  pending_approval: "bg-amber-100 text-amber-900 border-amber-300",
  approved: "bg-blue-100 text-blue-900 border-blue-300",
  processing: "bg-blue-100 text-blue-900 border-blue-300 animate-pulse",
  sent: "bg-green-100 text-green-900 border-green-300",
  failed: "bg-red-100 text-red-900 border-red-300",
  cancelled: "bg-gray-100 text-gray-600 border-gray-300",
};

export const jobStatusLabels: Record<AutomationJobStatus, string> = {
  pending_approval: "Needs approval",
  approved: "Queued",
  processing: "Sending…",
  sent: "Sent",
  failed: "Failed",
  cancelled: "Cancelled",
};
